var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6004 4.78539V3.08253H12.6101V0.433594H1.65552V3.08247H5.6649V4.79193C2.42622 4.95753 0 5.63625 0 6.44841C0 7.26057 2.42622 7.93923 5.6649 8.10489V13.4117C6.1608 13.5131 6.67416 13.5661 7.2 13.5661C7.67844 13.5661 8.14662 13.5221 8.6004 13.4379V8.11143C11.9064 7.95795 14.4 7.27179 14.4 6.44841C14.4 5.62503 11.9064 4.93887 8.6004 4.78539ZM7.2 7.49511C3.58734 7.49511 0.65874 6.95091 0.65874 6.27939C0.65874 5.70615 2.793 5.22549 5.6649 5.09733V7.04445C6.15174 7.11459 6.64236 7.14987 7.13268 7.14987C7.62324 7.14987 8.11386 7.11459 8.6004 7.04445V5.09139C11.54 5.21079 13.741 5.69703 13.741 6.27933C13.741 6.95085 10.8123 7.49511 7.2 7.49511Z",
    fill: "#4B5462"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 13.1325,
    fill: "white",
    transform: "translate(0 0.433594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.1cb0958e8035015ccc5963a4532bdff0.svg";
export { ForwardRef as ReactComponent };